import React from "react";

import { Table, Th, Thead, Tr, Td } from "reactable";
import { appHelpers } from "../../_helpers";

class ReportsTable extends React.Component {
  getTSCNaira = item => {
    let TSCNaira = item.Items.filter(tsc => tsc.Name === "566")[0];
    if (TSCNaira) {
      return appHelpers.numberWithCommas(TSCNaira.Info.TotalAmount);
    }
    return "0.00";
  };

  getTSCDollar = item => {
    let TSCDollar = item.Items.filter(tsc => tsc.Name === "840")[0];
    if (TSCDollar) {
      return appHelpers.numberWithCommas(TSCDollar.Info.TotalAmount);
    }
    return "0.00";
  };

  render() {
    let { data } = this.props;

    return (
      <div>
        <Table
          className="table table-striped table-hover"
          id="table"
          sortable={true}
          itemsPerPage={15}
          pageButtonLimit={10}
        >
          <Thead>
            <Th column="AirlineName">
              <span>Airline Name</span>
            </Th>
            <Th column="ManifestUploaded">
              <span>Manifest Received</span>
            </Th>
            <Th column="ManifestApproved">
                <span>Manifest Approved</span>
            </Th>
            <Th column="TSCAmountNGN">
              <span>TSC Amount NGN</span>
            </Th>
            <Th column="TSCAmountUSD">
              <span>TSC Amount USD</span>
            </Th>

            <Th column="AmountCredited">
              <span>Amount Credited</span>
            </Th>
            <Th column="AmountSwept">
              <span>Amount Swept</span>
            </Th>
          </Thead>

          {data.map((item, i) => (
            <Tr key={i}>
              <Td column="AirlineName" className="text-capitalize">
                {item.Name}
              </Td>
              <Td column="ManifestUploaded">{item.Info.ManifestCount}</Td>
              <Td column="ManifestApproved">{item.Info.ManifestCount}</Td>
              <Td column="TSCAmountNGN">
                <span>&#8358; {this.getTSCNaira(item)} </span>
              </Td>
              <Td column="TSCAmountUSD"><span>&#36; {this.getTSCDollar(item)}</span></Td>
              <Td column="AmountCredited">{"0.00"}</Td>
              <Td column="AmountSwept">{"0.00"}</Td>
            </Tr>
          ))}
        </Table>
      </div>
    );
  }
}
export default ReportsTable;



// WEBPACK FOOTER //
// ./src/views/reports/reports-table.js